import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import PoiDetailCard from '../components/PoiDetailCard';
import ButtonClose from '../components/ButtonClose';
import { useStores } from '../use.store';
import Layout from '../components/Layout';

const PoiDetail = observer(({ interactiveRef }) => {
    const { mapStore, mainStore } = useStores();

    const handleClose = () => {
        if (mapStore.currentFreeShape) {
            mainStore.setSelectedPoiDetail(null);
            mainStore.setFloorguideSelectedAmenity(null);

            [...mapStore.freeShapes, ...mapStore.model3ds].forEach((e) => {
                interactiveRef.current.changeTopImage(e._id, null);
            });
            mapStore.setCurrentWayfindingGroup(0);
            mapStore.setIsShowOverview(false);
            // mapStore.setCurrentFreeShape([]);
        } else {
            mainStore.setSelectedPoiDetail(null);
        }
    };

    return (
        <Layout
            className="absolute w-screen h-[100dvh] top-0 flex flex-1 flex-col p-4 justify-center items-center bg-black/60 backdrop-blur-[12px]"
            isSelectedPage={
                mainStore.selectedPoiDetail && mainStore.isPoiOverlay
            }
            adjustedZIndex="z-[99999]"
        >
            {mainStore.selectedPoiDetail && mainStore.isPoiOverlay && (
                <Fragment>
                    <PoiDetailCard interactiveRef={interactiveRef} />
                    <ButtonClose handleClose={handleClose} />
                </Fragment>
            )}
        </Layout>
    );
});

export default PoiDetail;
